// Healthcare.js
import React, { useState, useContext } from "react";
import "./Healthcare.css";
import { ChatContext } from "../ChatContext";
import { useStrings } from '../strings/StringsContext';


const prompts = [
  { title: "HCPs attending conferences", content: "List of healthcare professionals attending upcoming conferences." },
  { title: "Summarize clinical insights", content: "Summary of the latest clinical insights across various studies." },
  { title: "HCPs to meet with next", content: "Recommended healthcare professionals to meet next based on priorities." },
  { title: "Analyze differentiators", content: "Comparative analysis of product differentiators and advantages." },
  { title: "Show me declining prescribers", content: "Here are the prescribers showing declining trends." },
  { title: "What are my pending medical inquiries?", content: "List of pending medical inquiries assigned to you." },
];

const imageCycle = ["/sample1.jpg", "/sample2.jpg", "/sample3.jpg"];

const Healthcare = () => {
  const { setTriggeredPrompt, addMessage, setChatState } = useContext(ChatContext);
  const [searchText, setSearchText] = useState("");
  const { strings, agentName } = useStrings(); 

  const cardsToShow = prompts.map((prompt, idx) => ({
    ...prompt,
    image: imageCycle[idx % imageCycle.length],
  }));

  // Send text to chatbot & expand
  const sendSearchToChatbot = (text) => {
    if (!text.trim()) return;

    setTriggeredPrompt(text);
    addMessage({
      type: "user",
      text,
      timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    });

    // Open chatbot in expanded mode
    setChatState((prev) => ({ ...prev, isOpen: true, isExpanded: true }));

    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submit
      sendSearchToChatbot(searchText);
    }
  };

  return (
    <div className="healthcare-dashboard">
      <div className="header-section">
        <h1>Good morning! How may I help you?</h1>
        <img src="/agentforce-flying.png" alt="Agentforce Flying" className="agentforce-flying" />

        {/* Search bar */}
        <div className="search-bar">
          <img src="/bot-avatar.png" alt="Agentforce Icon" />
          <input
            type="text"
            placeholder="Ask SakCare Agent anything…"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button
            className="search-send-button"
            onClick={() => sendSearchToChatbot(searchText)}
          >
            {/* Chat arrow icon same as Chatbot */}
              <span className="arrow-icon">➤</span>
          </button>
        </div>

        {/* Prompt buttons */}
        <div className="prompt-buttons">
          {prompts.map((prompt, index) => (
            <button
              key={index}
              className="prompt-button"
              onClick={() => sendSearchToChatbot(prompt.title)}
            >
              {prompt.title}
            </button>
          ))}
        </div>
      </div>

      {/* Announcements section */}
      <div className="announcement-section">
        <h2>Announcements</h2>
        <div className="announcement-grid">
  {cardsToShow.slice(0, 6).map((card, index) => (
    <div className="announcement-card" key={index}>
      <img className="card-top-image" src={card.image} alt={card.title} />
      <div className="card-content">
        <div className="date">July 28, 2025</div>
        <div className="title">{card.title}</div>
        <div className="description">{card.content}</div>
      </div>
    </div>
  ))}
</div>
      </div>
    </div>
  );
};

export default Healthcare;
